import { render } from "./SecondaryTitle.vue?vue&type=template&id=270180bf&scoped=true"
import script from "./SecondaryTitle.vue?vue&type=script&lang=js"
export * from "./SecondaryTitle.vue?vue&type=script&lang=js"

import "./SecondaryTitle.vue?vue&type=style&index=0&id=270180bf&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270180bf"]])

export default __exports__